import { useState } from 'react'
import { MdMenu } from 'react-icons/md'
import FadeIn from 'react-fade-in'

import NavLinks from './NavLinks'

function Nav() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="nav-wrapper">
      {isOpen && (
        <FadeIn>
          <div className="nav-popup">
            <NavLinks setIsOpen={setIsOpen} />
          </div>
        </FadeIn>
      )}
      <div
        className="nav"
        onClick={() => setIsOpen(!isOpen)}
        tabindex="0"
        role="button"
        title="Navigate"
      >
        <MdMenu />
      </div>
    </div>
  )
}

export default Nav
